import React from 'react'

export default function WhoWeAre() {
  return (
    <div>
      <h2 className="d-flex poppins fw-600 align-items-center ">
    <mark className="px-3 text-primary">Who We Are</mark>
    <hr />
  </h2>
  <div className="my-5">
    <p>
      2nd Gear.in is a leading online marketplace from India showcasing
      used Surplus. This equipment is from several sectors like
      Construction, Mining, Transportation, Agriculture, Lifting etc.
    </p>
    <p>
      More than 1500 equipment sale out through 2nd Gear.in site & more
      than 10,000 equipment available on rental, covering over 350 brands
      & categories. The process of Buying, Selling, leasing, renting is
      simple & user friendly.
    </p>
    <p>
      As a value added service, also provides inspection & verification of
      equipment thru’ its vast & expanding on-ground network.
    </p>
    <p>
      So if you are looking to buy/sell/rent the equipment which 2nd Gear
      is Indian or International, as an individual or institute, you are
      likely to find the best deal on.
    </p>
  </div></div>
  )
}
